import { Link } from "@quintype/components";
import React from "react";
import "./my-account-button.m.css";
import User from "../other-icons/User";

function MyAccountButton({ onAccountHandler }) {
  return (
    <div styleName="wrapper" onClick={onAccountHandler}>
      <Link styleName="my-account" target="_blank">
        <User color="#0091ac" width="10.31px" height="11.61px" />
        My Account
      </Link>
    </div>
  );
}

export default MyAccountButton;
